/* eslint-disable no-underscore-dangle */
import {
    CarouselDisplayValueModel,
    DisplayValueModel,
} from "../models/displayValue"
import DynamicParamsService from "../services/dynamicParams"
export default class StructUtils {
    /**
     * getValueFromArray récupère la valeur d'un object en fonction d'un tableau d'attr
     * @param obj objet à explorer
     * @param array tableau des attr (ex. ["attr1", attr2 ...])
     * @returns si ["attr1", attr2] retourn obj.attr1.attr2
     */
    public static getValueFromArray(obj: any, array: Array<string>): unknown {
        let tmp = obj
        let err = false
        for (let index = 0; index < array.length; index += 1) {
            const currentAttr = array[index]
            if (
                tmp &&
                (Object.prototype.hasOwnProperty.call(tmp, currentAttr) ||
                    currentAttr in tmp)
            ) {
                tmp = tmp[currentAttr]
            } else {
                err = true
                break
            }
        }
        return err ? null : tmp
    }

    /**
     * Extrait le source / clé / optionalSubKeysAttribut
     * @param key
     * @return {[source:string, key:string, optionalSubKeysAttribut: Array<string>]}
     */
    public static extractSourceKey(
        key: string
    ): [string | undefined, string | undefined, Array<string> | undefined] {
        let sourcePrefix
        let trimedKey
        let optionalSubKeysAttribut
        if (key) {
            const splitedKey = key.split(".")
            // source.key la taille doit etre de 2
            if (splitedKey.length === 2) {
                ;[sourcePrefix, trimedKey] = splitedKey
            } else if (splitedKey.length > 2) {
                sourcePrefix = splitedKey.shift()
                trimedKey = splitedKey.shift()
                optionalSubKeysAttribut = splitedKey
            } else if (splitedKey.length > 0) sourcePrefix = splitedKey.shift()

            return [sourcePrefix, trimedKey, optionalSubKeysAttribut]
        }

        return [undefined, undefined, undefined]
    }

    /**
     * findMultiTypes Renvoie l'index si la valeur est trouvé dans le tableau
     * Si type primitif === sinon check sur le _id
     * @param value valeur à trouver
     * @param array tableau
     * @returns {number} -1 si pas trouvé index sinon
     */
    public static findMultiTypes(value: any, array: Array<any>): number {
        let res = -1
        let comparator = (e: any) => e === value

        // si type non primitif test sur _id
        if (value?._id) {
            comparator = (e: any) => e && e._id && e._id === value._id
        }
        // si type non primitif test sur id
        else if (value?.id) {
            comparator = (e: any) => e && e.id && e.id === value.id
        }

        if (array?.length) {
            res = array.findIndex(comparator)
        }

        return res
    }

    /**
     * hasStringsInArray prend deux tableaux de string si toute les string de tableA sont dans tabeB renvoie true
     * @param tableA objet à tester
     * @param tableB tableau qui doit contenir les items de tableA
     * @returns {boolean}
     */
    public static hasStringsInArray(
        tableA: Array<string>,
        tableB: Array<string>
    ): boolean {
        let res = true
        tableA.forEach((s) => {
            if (tableB.indexOf(s) === -1) res = false
        })
        return res
    }

    /**
     * Transforme un tableau l'objet en tableau de DisplayValueModel
     * @param displayValueMap Nom de l'attr de l'obj qui fera lieux de displayValue
     * @param valueMap Nom de l'attr de l'obj qui fera lieux de value
     * @param obj objet de type non connue
     * @returns Tableau de DisplayValueModel
     */
    public static toDisplayValueModel = (
        displayValueMap: string,
        valueMap: string,
        obj: Array<any>
    ): Array<DisplayValueModel> => {
        if (obj && obj.length) {
            const res: Array<DisplayValueModel> = []
            obj.forEach((element: any) => {
                res.push({
                    _id: element[valueMap],
                    displayValue: element[displayValueMap],
                    value: element[valueMap],
                })
            })
            return res
        }

        return []
    }

    /**
     * Transforme un tableau l'objet en tableau de string en fonction d'un index
     * @param valueMap Nom de l'attr de l'obj qui fera lieux de value
     * @param obj objet de type non connue
     * @returns Tableau de String
     */
    public static toStringArray = (
        valueMap: string,
        obj: Array<any>
    ): Array<string> => {
        if (obj && obj.length) {
            const res: Array<string> = []
            obj.forEach((element: any) => {
                res.push(element[valueMap])
            })
            return res
        }

        return []
    }

    /**
     * deleteArrayDouble
     */
    public static deleteArrayDouble(arr: Array<unknown>): Array<unknown> {
        return arr.filter((v, i) => arr.indexOf(v) === i)
    }
}
